import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { LanguageSelector } from './LanguageSelector';

export const Header = () => {
  const { t } = useTranslation();
  return (
    <header
      data-testid="site-header"
      role="banner"
      className="sticky top-0 z-40 border-b bg-[hsl(var(--background))]/80 backdrop-blur-lg border-[hsl(var(--border))]"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2" aria-label="FluxiPay - Inicio">
          <img 
            src={`${process.env.PUBLIC_URL}/images/fluxipay-logo.gif`}
            alt="FluxiPay - Pasarela de pagos crypto para e-commerce"
            className="h-[62px] w-auto"
            width="186"
            height="62"
            loading="eager"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-6" role="navigation" aria-label="Main navigation">
          <a href="#features" data-testid="nav-features-link" className="text-sm text-foreground/80 hover:text-[hsl(var(--primary-glow))] transition-smooth">{t('header.features')}</a>
          <a href="#integration" data-testid="nav-docs-link" className="text-sm text-foreground/80 hover:text-[hsl(var(--primary-glow))] transition-smooth">{t('header.integration')}</a>
          <a href="#pricing" data-testid="nav-pricing-link" className="text-sm text-foreground/80 hover:text-[hsl(var(--primary-glow))] transition-smooth">{t('header.pricing')}</a>
          <a href="#contact" data-testid="nav-contact-link" className="text-sm text-foreground/80 hover:text-[hsl(var(--primary-glow))] transition-smooth">{t('header.contact')}</a>
        </nav>
        <div className="flex items-center gap-2">
          <LanguageSelector />
          <Link to="/portal/login">
            <Button data-testid="signin-button" variant="ghost" className="hidden sm:inline-flex hover:bg-[hsl(var(--surface))] transition-smooth">{t('header.signin')}</Button>
          </Link>
          <Link to="/portal/register">
            <Button data-testid="cta-header-button" className="btn-neon">{t('header.signup')}</Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
